import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders modal markup under document.body. Dialogs opened from the sidebar
 * must escape it — its entrance animation makes it the containing block for
 * position: fixed, which pinned backdrops to the sidebar column.
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
